type CompareSitePlanAnimationType =
  | 'linear'
  | 'easeOut'
  | 'easeInQuad'
  | 'easeOutQuad'
  | 'easeInOutQuad'
  | 'easeInCubic'
  | 'easeOutCubic'
  | 'easeInOutCubic'
  | 'easeInQuart'
  | 'easeOutQuart'
  | 'easeInOutQuart'
  | 'easeInQuint'
  | 'easeOutQuint'
  | 'easeInOutQuint';

export type CompareSitePlanZoomToElement = (
  node: string | HTMLElement,
  scale?: number,
  animationTime?: number,
  animationType?: CompareSitePlanAnimationType,
) => void;

export const getCompareSitePlanMarkerElementId = (unitId: string | number): string => {
  const safeUnitId = String(unitId).replace(/[^A-Za-z0-9_-]/g, '-');
  return `compare-siteplan-marker-${safeUnitId}`;
};

export const focusCompareSitePlanMarker = (
  markerElementId: string,
  zoomToElement: CompareSitePlanZoomToElement,
): boolean => {
  if (!document.getElementById(markerElementId)) {
    return false;
  }

  zoomToElement(markerElementId, 1, 250, 'easeOut');
  return true;
};
